module.exports = __webpack_public_path__ + "images/stickers/residue.38e223183bf85ac21aa3.png";